import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { HubEndpoint } from '../../../hub/constants/hub-endpoint';
import { CompartmentEndpoint } from '../../constants/compartment-endpoint';
import { CompartmentOverview } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CompartmentOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData({
    hubId,
    compartmentId,
  }: {
    hubId: number;
    compartmentId: number;
  }): Observable<CompartmentOverview> {
    return this.http
      .withLoading()
      .get<CompartmentOverview>(
        `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Overview}`,
      );
  }

  updateCompartment({
    hubId,
    compartmentOverview,
  }: {
    hubId: number;
    compartmentOverview: CompartmentOverview;
  }): Observable<CompartmentOverview> {
    return this.http
      .withLoading()
      .post<CompartmentOverview>(
        `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}`,
        compartmentOverview,
      );
  }
}

